// @flow

import type { DepartmentSpecificScriptsState } from "./types";

export const initialState: DepartmentSpecificScriptsState = {
  requestsInProgress: 0,
  list: null,
  schema: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  modals: {
    showAddDepartmentSpecificScriptModal: false,
    modalStep: 1,
    showEditModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showDiscardModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
    showEditAssignmentsModal: false,
  },
};

export default initialState;
